<template>
    <div class="module-teaser">
        <CheckIcon
            v-if="finished"
            :size="4"
            :absolute="true"
            transition="check"
        />
        <router-link :to="{name: 'module', params: {module}}">
            <figure @click="playReveal">
                <img class="block" :src="require(`@/assets/home/LE${module}.jpg`)">
                <figcaption class="blue-background">
                    {{ title }}
                </figcaption>
            </figure>
        </router-link>
        <router-link
            :to="{name: 'module', params: {module}}"
            class="module-link"
        >
            Lerneinheit {{ module }}
        </router-link>
        <a
            class="download-button button"
            :href="`./pdf/${pdfFileName}`"
            :download="pdfFileName"
        >
            Team-Leitfaden (PDF)
        </a>
    </div>
</template>

<script>
import modules from '@/static/modules.json';

export default {
    name: 'ModuleTeaser',
    props: {
        module: {
            type: String,
            required: true
        }
    },
    computed: {
        title()
        {
            return modules[this.module].title;
        },
        finished()
        {
            return this.$store.state.progress[this.module].finished;
        },
        pdfFileName()
        {
            const module = this.module.replace('.', '-');
            return `Team-Leitfaden_LE_${module}.pdf`;
        }
    },
    methods: {
        playReveal()
        {
            this.$audioController.play('reveal', {volume: 0.3});
        }
    }
};
</script>

<style lang="scss" src="./ModuleTeaser.scss" />
